import { createStore } from 'vuex';
import { AUTH_TOKEN, ID_PARTNER } from '@/constants';

export type AppState = {
  showSpinner: boolean;
  token: string | null;
  idPartner: number | null;
};

export default createStore<AppState>({
  state: {
    showSpinner: false,
    token: null,
    idPartner: null,
  },
  getters: {
    getToken(state: AppState): string | null {
      if (!state.token) {
        state.token = window.localStorage.getItem(AUTH_TOKEN) || null;
      }

      return state.token;
    },
    getIdPartner(state: AppState): number | null {
      if (!state.idPartner) {
        state.idPartner = Number(window.localStorage.getItem(ID_PARTNER)) || null;
      }

      return state.idPartner;
    },
  },
  mutations: {
    TOGGLE_SPINNER_MUTATION(state, payload) {
      state.showSpinner = payload;
    },
    SET_TOKEN_MUTATION(state, token) {
      state.token = token;
    },
    SET_ID_PARTNER_MUTATION(state, idPartner) {
      state.idPartner = idPartner;
    },
  },
  actions: {
    TOGGLE_SPINNER_ACTION(context, payload) {
      context.commit('TOGGLE_SPINNER_MUTATION', payload);
    },
    SET_TOKEN_ACTION(context, token) {
      window.localStorage.setItem(AUTH_TOKEN, token);
      context.commit('SET_TOKEN_MUTATION', token);
    },
    REMOVE_TOKEN_ACTION(context) {
      window.localStorage.removeItem(AUTH_TOKEN);
      context.commit('SET_TOKEN_MUTATION', null);
    },
    SET_ID_PARTNER_ACTION(context, idPartner) {
      window.localStorage.setItem(ID_PARTNER, idPartner);
      context.commit('SET_ID_PARTNER_MUTATION', idPartner);
    },
  },
  modules: {},
});
